// src/pages/SignUpPage.js
import React from 'react';
import SignupForm from '../components/SignupForm';
import '../App.css';
import Header from '../components/Header';

const SignUpPage = () => (
    <>
    <Header />
    <div className="app-container">
      <div className="left-image">
        <img src="/image.png" alt="Invoices Illustration" />
      </div>
    <SignupForm />
  </div>
  </>
);

export default SignUpPage;

